"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var _MetricViewDeclaration2 = _interopRequireDefault(require("./__generated__/MetricViewDeclaration.graphql"));
var _MetricViewMeasurements2 = _interopRequireDefault(require("./__generated__/MetricViewMeasurements.graphql"));
var React = _interopRequireWildcard(require("react"));
var _reactRelay = require("react-relay");
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _DurationsOverTime = _interopRequireDefault(require("web/shared/telemetry/charts/DurationsOverTime"));
var _Histogram = _interopRequireDefault(require("web/shared/telemetry/charts/Histogram"));
var _MarkerRates = _interopRequireDefault(require("web/shared/telemetry/charts/MarkerRates"));
var _MeasurementsTable = _interopRequireDefault(require("web/shared/telemetry/charts/MeasurementsTable"));
var _PercentileStrip = _interopRequireDefault(require("web/shared/telemetry/charts/PercentileStrip"));
var _PhaseBreakdown = _interopRequireDefault(require("web/shared/telemetry/charts/PhaseBreakdown"));
var _markerMeanings = require("web/shared/telemetry/format/markerMeanings.js");
var _perfViewsStyles = require("web/shared/telemetry/perfViews.styles.js");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
* One metric's measurements in the window, with the charts that read them and
* the line that says what was recorded.
*
* The suspending half of the metric page. Both reads happen here, and the
* sentence describing them is here too rather than in the frame above: it
* counts records and names the declaration, so it cannot be written before
* either has answered. The frame keeps what the route already knows — the
* title and the way back — so those stay on screen while this waits.
*/ // How many measurements one read fetches, whatever page size is showing. The
// server's own ceiling, so paging never needs a second request.
const MEASUREMENT_FETCH_LIMIT = 500;
const METRIC_VIEW_MEASUREMENTS = _MetricViewMeasurements2.default;
const METRIC_VIEW_DECLARATION = _MetricViewDeclaration2.default; /**
                                                                 * One recorded measurement, with the marks made inside it in the order they
                                                                 * happened.
                                                                 *
                                                                 * Derived from the read rather than written out, so a field the server
                                                                 * renames, or makes nullable, stops type-checking at the charts that read it
                                                                 * rather than arriving as something else at run time.
                                                                 *
                                                                 * `endedAt` and `durationMs` are null while the measurement is open — or
                                                                 * forever, if it never reported back, which is a finding rather than a gap.
                                                                 * `dimensionsJson` is the row's own tags as a JSON string, deliberately a
                                                                 * string rather than a shape: each metric tags what is worth correlating for
                                                                 * it, so there is nothing a schema could name.
                                                                 */ /**
                                                                    * What a metric's declaration says about itself.
                                                                    *
                                                                    * The read answers null for a key the acting product declares no metric for,
                                                                    * which is an ordinary answer rather than a failure, so the field's own null is
                                                                    * handled where it arrives and this is the shape behind it.
                                                                    */ /**
                                                                       * One marker a metric declares, and what it means.
                                                                       *
                                                                       * The description is the author's own words, written when the marker was
                                                                       * declared, and shown beside its phase so a stretch of time is named rather
                                                                       * than just labeled.
                                                                       */
function MetricView(props) {
  const options = {
    fetchKey: props.reloadKey,
    fetchPolicy: "network-only"
  }; // Two reads rather than one: they are independent, and a declaration that is
  // null is an ordinary answer — a retired metric or a stale link reaches this
  // page — so it is not worth holding the measurements for.
  const declared = (0, _reactRelay.useLazyLoadQuery)(METRIC_VIEW_DECLARATION, {
    metricKey: props.metricKey
  }, options);
  const measured = (0, _reactRelay.useLazyLoadQuery)(METRIC_VIEW_MEASUREMENTS, {
    metricKey: props.metricKey,
    window: props.window,
    limit: MEASUREMENT_FETCH_LIMIT
  }, options);
  const declaration = declared.internalMetricDeclaration;
  const records = measured.internalMetricMeasurements;
  const markerMeanings = (0, _markerMeanings.markerMeaningsOf)(declaration);
  const unsealed = records.filter(record => record.endedAt == null).length;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("p", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_perfViewsStyles.styles.intro)), {}, {
      children: [declaration != null ? "".concat(declaration.description, " ") : "", "Recorded one call in", " ", declaration != null ? declaration.sampleOneIn : "?", ". The", " ", records.length, " most recent measurements in this window", unsealed > 0 ? ", ".concat(unsealed, " of them never ended") : "", ". Durations are wall clock, so anything at or above a millisecond is faithful and anything below it is noise."]
    })), records.length === 0 ? /*#__PURE__*/(0, _jsxRuntime.jsx)("p", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_perfViewsStyles.styles.muted)), {}, {
      children: "Nothing recorded for this metric in this window."
    })) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_PercentileStrip.default, {
        records: records
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_perfViewsStyles.styles.panels)), {}, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Histogram.default, {
          records: records
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_DurationsOverTime.default, {
          records: records
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_PhaseBreakdown.default, {
          records: records,
          markerMeanings: markerMeanings
        })]
      })), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MeasurementsTable.default, {
        records: records
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MarkerRates.default, {
        records: records,
        markerMeanings: markerMeanings
      })]
    })]
  });
}
var _default = exports.default = MetricView;